export default {
  namespaced: true,

  state: {
    events: []
  },

  mutations: {
    emit(state, payload) {
      state.events.push(...payload)
    },
  },

  getters: {
    events: state => state.events
  },

  actions: {
    emit({commit}, payload) {
      commit('emit', payload)
    }
  }
}